import { IJNativeEvent } from "../JNative";
import { Point } from "../Ui/Point";
import { NAMESPACE } from "./_Namespace";

export class EventHelper
{
    public static classNamespace = NAMESPACE + "EventHelper";
    public static className = "EventHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Public Methods

    public static getInputCoordinates(evt: IJNativeEvent)
    {
        if (evt.originalEvent instanceof MouseEvent)
            return new Point(evt.originalEvent.pageX, evt.originalEvent.pageY);

        if (evt.originalEvent instanceof TouchEvent)
        {
            const input = evt.originalEvent.touches[0] || evt.originalEvent.changedTouches[0];
            return new Point(input.pageX, input.pageY);
        }
    }

    // #endregion
}